import AllocationForm from "@/modules/work/jobs/allocation/crud/form";
import { EvtHeader } from "components/header";
import React from "react";
import { useJob } from "../../../context";

const CreateJobAllocation = () => {
  const { type } = useJob();
  return (
    <div className="flex-1 ">
      <EvtHeader title="Create budget Allocation" />
      <div className="max-w-md p-6">
        <AllocationForm type={type} />
      </div>
    </div>
  );
};

export default CreateJobAllocation;
